import colors from "resources/theme/colors";
import { FiAlertCircle } from "react-icons/fi";
import { SimpleGrid } from "@chakra-ui/layout";
import Card2Horizontal from "components/Cards/Card2Horizontal";
import { Image } from "@chakra-ui/react";
import cashCheck from "assets/images/svgs/cash-check.svg";
import iconeCashClock from "assets/images/svgs/cash-clock.svg";
import { useContaStore } from "features/conta/store";
import { ContaTotais } from "features/conta/typings";
import { OperacaoEnum } from "resources/enums/conta";
import CardSaldo from "components/Cards/CardSaldo";
import ContasRecorrentesNaoLancadas from "./components/ContasRecorrentesNaoLancadas";
import moment from "moment";
import { formatMoney } from "infra/helpers/number";

export default function DashboardContaReceber({
  data,
  isFetching = false,
}: {
  data?: ContaTotais | undefined;
  isFetching?: boolean;
}) {
  const {
    filters: { operacao, dataInicio, dataFim },
    update,
  } = useContaStore();

  const onClickPagas = () => {
    update({
      page: 1,
      atraso: null,
      pago: true,
    });
  };

  const onClickEmAberto = () => {
    update({
      page: 1,
      atraso: false,
      pago: false,
    });
  };

  const onClickEmAtraso = () => {
    update({
      page: 1,
      pago: null,
      atraso: true,
    });
  };

  const getTextPagas = () => {
    const quantidadeCobranca = data?.liquidada.quantidade ?? 0;

    if (operacao === OperacaoEnum.Despesa) {
      return quantidadeCobranca === 1
        ? `${quantidadeCobranca} despesa paga`
        : `${quantidadeCobranca} despesas pagas`;
    }
    return quantidadeCobranca === 1
      ? `${quantidadeCobranca} cobrança recebida`
      : `${quantidadeCobranca} cobrança recebidas`;
  };

  const getMonthContasRecorrentes = () => {
    if (
      dataInicio &&
      dataFim &&
      moment(dataInicio).isSame(moment(dataFim), "month")
    ) {
      return moment(dataInicio).format("YYYY-MM");
    }
  };

  return (
    <>
      <SimpleGrid columns={{ sm: 1, md: 2, lg: 5 }} gap="16px" mb="32px">
        <ContasRecorrentesNaoLancadas
          operacao={operacao}
          mes={getMonthContasRecorrentes()}
        />

        <Card2Horizontal
          icon={<Image src={cashCheck} h="16px" w="auto" mt="6px" ml="4px" />}
          color={colors.orange}
          bg={colors.green100}
          description={getTextPagas()}
          title={formatMoney(data?.liquidada.valor ?? 0)}
          loading={isFetching}
          onClick={onClickPagas}
        />

        <Card2Horizontal
          icon={
            <Image src={iconeCashClock} h="24px" w="auto" mt="6px" ml="4px" />
          }
          color={colors.yellow}
          bg={colors.yellow50}
          description={`${data?.pendente.quantidade ?? 0} ${
            operacao === OperacaoEnum.Despesa ? "despesas" : "cobranças"
          } em aberto`}
          title={formatMoney(data?.pendente.valor ?? 0)}
          loading={isFetching}
          onClick={onClickEmAberto}
        />

        <Card2Horizontal
          icon={<FiAlertCircle fontSize="24px" color={colors.red} />}
          color={colors.red}
          bg={colors.red100}
          description={`${data?.atraso.quantidade ?? 0} ${
            operacao === OperacaoEnum.Despesa ? "despesas" : "cobranças"
          } em atraso`}
          title={formatMoney(data?.atraso.valor ?? 0)}
          loading={isFetching}
          onClick={onClickEmAtraso}
        />

        <CardSaldo />
      </SimpleGrid>
    </>
  );
}
